export default __webpack_public_path__ + "static/media/High-precision-Scans.ad03aebb.png";